import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ScheduleEventsService {

  constructor(private http: HttpClient) { }

  className = 'ScheduleEventsService';

  getEvents() {
    const events = [
      {
        SEVERITY: "HIGH",
        TITLE: "Entrega Informe definitivo",
        DESCRIPTION: "Revisión de sistemas y seguridad",
        DATE: "2019-07-23T18:25:43.511Z"
      },
      {
        SEVERITY: "MEDIUM",
        TITLE: "Entrega Informe definitivo definitivo definitivo",
        DESCRIPTION: "Revisión de sistemas y seguridad",
        DATE: "2019-07-23T18:25:43.511Z"
      },
      {
        SEVERITY: "LOW",
        TITLE: "Entrega Informe definitivo",
        DESCRIPTION: "Revisión de sistemas y seguridad",
        DATE: "2019-07-23T18:25:43.511Z"
      },
      {
        SEVERITY: "LOW",
        TITLE: "Entrega Informe definitivo",
        DESCRIPTION: "Revisión de sistemas y seguridad",
        DATE: "2019-07-24T18:25:43.511Z"
      },
      {
        SEVERITY: "LOW",
        TITLE: "Entrega Informe definitivo",
        DESCRIPTION: "Revisión de sistemas y seguridad",
        DATE: "2019-07-30T18:25:43.511Z"
      }
    ];

    // mapfre-auditlib-calendar reads lowercase `date` and `severity`
    return of(events.map(event => ({ ...event, severity: event.SEVERITY, date: event.DATE })));

  }
}
